import {
  HospitalPrescriptionRequestSourceModel,
  IHospitalPrescriptionRequestSourceModel,
} from '@common/models';
import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';

export class HospitalPrescriptionRequestSourceService {
  private static baseUrl: string = '/api/hospitalPrescriptionRequestSources';

  static tags = {
    upsertHospitalPrescriptionRequestSource:
      'upsertHospitalPrescriptionRequestSource',
    deleteHospitalPrescriptionRequestSource:
      'deleteHospitalPrescriptionRequestSource',
  };

  static upsertHospitalPrescriptionRequestSource = (
    data: IHospitalPrescriptionRequestSourceModel,
  ): Promise<HospitalPrescriptionRequestSourceModel> => {
    return trackPromise(
      new Promise<IHospitalPrescriptionRequestSourceModel>(
        (resolve, reject) => {
          http(`${this.baseUrl}`)
            .post<IHospitalPrescriptionRequestSourceModel>(data)
            .then((response) => {
              resolve(new HospitalPrescriptionRequestSourceModel(response));
            })
            .catch((err) => {
              reject(err);
            });
        },
      ),
      this.tags.upsertHospitalPrescriptionRequestSource,
    );
  };

  static deleteHospitalPrescriptionRequestSource = (
    hospitalPrescriptionRequestSourceId: number,
  ): Promise<boolean> => {
    return trackPromise(
      new Promise<boolean>((resolve, reject) => {
        http(`${this.baseUrl}/${hospitalPrescriptionRequestSourceId}`)
          .delete()
          .then(() => {
            resolve(true);
          })
          .catch((err) => {
            reject(err);
          });
      }),
      this.tags.deleteHospitalPrescriptionRequestSource,
    );
  };
}
